import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import {
  AppBar,
  Box,
  Button,
  Divider,
  Toolbar,
  Typography
} from '@mui/material';
import Logo from 'src/components/Logo';

function TopBar({ className, ...rest }) {
  return (
    <AppBar
      color="default"
      elevation={0}
      sx={{
        backgroundColor: (theme) => theme.palette.background.default,
        zIndex: (theme) => theme.zIndex.drawer + 1,
        ...(className && { className }),
      }}
      {...rest}
    >
      <Toolbar sx={{ height: 64 }}>
        <RouterLink to="/">
          <Box
            sx={{
              display: 'inline-block',
              mr: 2
            }}
          >
            <Logo />
          </Box>
        </RouterLink>

        <Typography
          variant="caption"
          color="textSecondary"
        >
          {/* Optional version or tagline */}
          {/* APP_VERSION */}
        </Typography>

        <Box sx={{ flexGrow: 1 }} />

        <Button
          color="secondary"
          component={RouterLink}
          to="/signin"
          variant="contained"
          size="small"
        >
          Sign In
        </Button>

        {/* Uncomment to enable Sign Up */}
        {/* <Divider orientation="vertical" flexItem sx={{ mx: 2 }} />
        <Button
          color="secondary"
          component={RouterLink}
          to="/signup"
          variant="contained"
          size="small"
        >
          Sign Up
        </Button> */}
      </Toolbar>
    </AppBar>
  );
}

TopBar.propTypes = {
  className: PropTypes.string
};

export default TopBar;
